module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gPgAh"))).then(() => parcelRequire('d0iPb'));